<template>
  <div>
    <ul v-bind:class="{'d-md-flex':true, 'cancel-modal-buttons':true}">
      <li v-bind:class="{'align-items-start':true,'has-second-button': this.cancelItem}">
        <a href="#" class="bax-btn bax-btn-orange bax-btn-cancel mt-3 mt-md-0" @click.prevent="open = true">Cancel order</a>
      </li>
      <li v-if="this.cancelItem">
        <a href="#" class="bax-btn bax-btn-orange mt-3 mt-md-0" @click.prevent="goToReview()">Cancel adding {{ this.cancelItem.toLowerCase() }}</a>
      </li>
    </ul>


    <vue-modal :open="open">
    <div class="bax-modal-content bax-modal-icon-content text-center">
      <div class="bax-icon bax-remove d-flex align-items-center justify-content-center">
        <i class="icon-delete"></i>
      </div>
      <h2>Cancel order?</h2>
      <p>Are you sure? All order lines will be lost.</p>
      <div class="bax-modal-action-items">
        <ul class="d-md-flex justify-content-center">
          <li>
            <a href="#" class="bax-btn bax-btn-orange mt-3 mt-md-0" @click.prevent="open = false">No, take me back to my order</a>
          </li>
          <li>
            <router-link
              :to="{ name: isTPN() ? 'homeTPN' : 'home' }"
              class="bax-btn bax-btn-bordered bax-btn-bordered-blue"
            >Yes, discard all order lines</router-link>
          </li>
        </ul>
      </div>
    </div>
    </vue-modal>
  </div>
</template>


<script>

import OrderService from '@/core/api/order/order.service';
import tpnMixin from '@/mixins/tpnMixin';

export default {
  name: 'CancelOrderModal',
  mixins: [tpnMixin],
  props: {
    patientCount: {
      type: Number,
    },
    drugCount: {
      type: Number,
      default: 0,
    },
    cancelItem: {
      type: String,
    },
    add_more: {
      type: Boolean,
    },
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    goToReview() {
      const data = {};
      data.orderRef = this.$route.params.orderId;

      OrderService.orderCleanup(data).then(() => {
        this.$router.push({
          path: this.isTPN() ? `/tpn/order/${this.$route.params.orderId}/review-complete` : `/order/${this.$route.params.orderId}/review-complete`,
        });
      });
    },
  },
};
</script>
